import { updateProfile } from './reducers';
export default updateProfile;
